import {useHistory, useParams} from 'react-router-dom';

import styled from "styled-components";
import {WhiteMain} from '../../components/main';
import TopBar from '../../components/top_bar';
import TopHeadroom from "../../components/top_headroom";
import MessageList from '../../components/message_list';
import Message from '../../components/message';
import {useMessage} from "../../api/message";
import useFeedback from "../../utils/use_feedback";
import CreatePrompt from "../../components/create_prompt";
import {themecolors} from "../../utils/themecolors";
import Comment2 from "../../components/comment2";

const Item = styled(({className, message, last}) => {
    const history = useHistory();
    const handleClick = () => {
        if (message.type === 2) {
            history.push(`/p/${message.comment.post_uuid}/x/c/${message.comment.uuid}/`);
        } else {
            history.push(`/message/${message.conversation_id}`);
        }
    }
    return (
        <div className={className} onClick={handleClick}>
            {message.comment ?
                <Comment2 comment={message.comment} contextual />
                :
                <Message showSubject message={message}/>
            }
        </div>
    );
})`
  ${Message} {
    border-bottom: ${({last}) => last ? 0 : 1}px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
  }
`;

const MessageThread = () => {
    const {id} = useParams()
    const {feedbackCh} = useFeedback();
    const messages = useMessage(feedbackCh, id);
    const lastMessage = messages ? messages[messages.length - 1] : false;
    return (
        <>
            <TopBar title="Message" back targetMessage={lastMessage} settings border />
            <WhiteMain>
                <MessageList>
                    {messages?.map((message, index) => (
                        <Item key={message.id} message={message} last={index === messages.length -1} />
                    ))}
                </MessageList>
            </WhiteMain>
            <CreatePrompt message={lastMessage} />
        </>
    );
}

export default MessageThread;
